import { FloorExceptionalClosingHoursResponse } from '@jooxter/api';
import { getDateTimeFromDateTimeAndStandardTime, IExceptionalOpeningHoursForm, toISO } from '@jooxter/utils';

export const useIFloorExceptionalClosingHoursFormToFloorExceptionalClosingHoursAdapter = () => {
  const floorExceptionalClosingHoursFormToFloorExceptionalClosingHoursAdapter = (
    floorExceptionalClosingHoursForm: IExceptionalOpeningHoursForm,
    floorId: number
  ): FloorExceptionalClosingHoursResponse => {
    return {
      title: floorExceptionalClosingHoursForm.title,
      timestampFrom: toISO(
        getDateTimeFromDateTimeAndStandardTime(
          floorExceptionalClosingHoursForm.start.date,
          floorExceptionalClosingHoursForm.start.time
        )
      ),
      timestampTo: toISO(
        getDateTimeFromDateTimeAndStandardTime(
          floorExceptionalClosingHoursForm.end.date,
          floorExceptionalClosingHoursForm.end.time
        )
      ),
      floorId,
    };
  };

  return [floorExceptionalClosingHoursFormToFloorExceptionalClosingHoursAdapter];
};
